import styled from 'styled-components';

export const FormWrapper = styled.div`
  align-items: flex-start;
  display: flex;
  margin: 0 auto;
  width: 100%;
  justify-content: space-between;
`;

export const Wrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  padding: 0 4px;
  margin-bottom: 24px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  gap: var(--form-group-gap, 24px);
`;
